<template>
  <div class="news-all">
    <div class="title">
        <span class="time">10.26<br>2017</span>
        <span class="tiel">美菜网创始人刘传军：通过互联网改变农业、农村和农民</span>
    </div>

    <div class="mat-content">
        <div class="tet-js">
            10月26日，中国食品报就党的十九大精神，深度采访了全国政协常委 副秘书长、民进中央副主席朱永新、中国生态文明研究与促进会副会长研究员王春益、中国农业科学院农产品加工研究所所长戴小枫及很多集团公司的董事和领导人。值得一提的是，美菜网创始人、CEO刘传军也受邀其中。<br/><br/>
            采访中，美菜网创始人、CEO刘传军表示，“正如十九大报告中指出的，农业农村农民问题是关系国计民生的根本性问题，必须始终把解决好“三农”问题作为全党工作重中之重。”作为互联网+农业的践行者，中共十九大制定的有关农业的政策，对美菜的发展将产生积极影响，美菜会时刻把党的十九大精神和公司的发展目标结合起来。<br/><br/>
        </div>
        <p align="center"><img src="@/assets/images/new-img/b6_01.jpg" width="640"></p>
        <div class="tet-js" style="text-align: center">
            美菜网创始人、CEO刘传军
        </div>
        <div class="tet-js">
            首先，通过互联网方式，改变农业、农村和农民。我国农业现状非常落后，流通环节链条多又长，1000公里的路程，经纪人、一级批发商、二批、三批、餐厅、菜市场等五六个中间环节层层抽成。美菜要做的就是打掉中间环节，为农民争取利益。<br/><br/>
            在过去3年多的发展过程中，美菜网通过自建物流美鲜送团队，日处理包裹数超过了100万个，配送的总里程超过了2亿公里，在全国近50个城市，每天发车超过了5000辆，累计近100万家餐厅。美菜更加希望通过互联网的方式来改变农业、农村和农民，改变以往农产品的销售方法，让农民不再为农产品销路发愁！<br/><br/>
            其次，加快布局全国，推进农业农村现代化。在谈到美菜接下来的动作，刘传军表示美菜将加快布局全国，把供应链深入下沉到农村市场，以现有中央仓为支点，以可持续盈利的经营策略为模式，依托互联网+物流体系，加强科技创新，利用大数据，标准化覆盖三、四、五线城市，为全国上千万个乡镇的农业服务，促进农业规模化的形成，打开农业农村现代化的大门。<br/><br/>
            最后，创新农业服务，促进农民就业创业。美菜的新农业模式在不断向中国三四五线城市渗透过程中，进一步推动了农业农村的发展，通过创造就业带动了数百万农民家庭从中受益；此外，很多有着土地情节的新农民，也会带着资金、资源，到农村承包土地，自己创业当老板。<br/><br/>
        </div>
        <p align="center"><img src="@/assets/images/new-img/b6_02.jpg" width="640"></p>
        <div class="tet-js" style="text-align: center">
            美菜网模式
        </div>
        <div class="tet-js">
            刘传军讲道，“习近平总书记在十九大报告中，对农业、农村、农民问题着墨颇多，“优先发展”“农业农村现代化”“农民就业创业”，这些概念都是首次见于中央对“三农”工作的部署。我是一个农民的孩子，认真学习总书记的十九大报告后深受激励，更加坚定了我的信心和决心。 ”<br/><br/>
            相信这次十九大的政策将进一步推进农业、农村、农民发展，吸引各行各业热爱“三农”的优秀人才加入队伍中。作为互联网+农业的践行者，未来，美菜将当仁不让地努力发挥自身的优势，坚持精准扶贫，助力农产品上行，为八亿农民谋幸福，为改变中国农业做出更大贡献。<br/><br/>
        </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
